//修改明细时   form弹框的视图模型数据
/**
 *  输入框的2种状态：State： error tip
 * Max： NumTextBox类型的最大数值
 * Min:NumTextBox类型的最小数值
 */

import _cloneDeep from 'lodash/cloneDeep'
const formColumns={
    takeTheir: [{
        "FieldName": "getCode",
        "Title": "提货码",
        "ControlType": "TextBox",
        "IsRequired": true,
        "IsScan": false,
        "Value": '',
        "maxLength": 50,
        "placeholder": '请输入提货码'
    }],
    TaxPrice:[{
        "FieldName": "TaxPrice",
        "Title": "单价",
        "ControlType": "NumTextBox",
        "IsRequired":true,
        State:'',
        Label:''
    }],
    RetailPrice:[{
        "FieldName": "RetailPrice",
        "Title": "零售价",
        "ControlType": "NumTextBox",
        "IsRequired":true,
        State:'',
        Label:''
    }],
    Quantity:[{
        ControlType:'NumTextBox',
        FieldName:'Quantity',
        Title:'零售数量',
        Value:'',
        State:'',
        Label:''
    }],
    Quantity2:[{
        ControlType:'NumTextBox',
        FieldName:'Quantity2',
        Title:'零售数量2',
        Value:'',
        State:'',
        Label:''
    }],
    WipeChange:[{
        ControlType:'TextBox',
        FieldName:'TotalTaxAmount',
        Title:'应收金额',
        IsRequired: false,
        SingleShow:true,
        Value:'',
        Style:{
            color:'red'
        }
    },{
        ControlType:'NumTextBox',
        FieldName:'WipeChange',
        Title:'抹零金额',
        IsRequired: false,
        Value:''
    }],
    TotalSale:[{
        ControlType:'NumTextBox',
        FieldName:'TotalSale',
        Title:'整单打折',
        IsRequired: false,
        Value:''
    }],
    SingleSale:[{
        ControlType:'NumTextBox',
        FieldName:'SingleSale',
        Title:'单品打折',
        IsRequired: false,
        Value:''
    }],
    SingleAmount:[{
        ControlType:'NumTextBox',
        FieldName:'SingleAmount',
        Title:'单品金额',
        IsRequired: false,
        Value:''
    }],
    VoucherDate:[{
        ControlType:'DatePicker',
        FieldName:'VoucherDate',
        Title:'日期',
        IsRequired: false,
        Value:''
    }],
    SingleMemo:[{
        ControlType:'TextBox',
        FieldName:'',
        Title:'商品名称',
        IsRequired: false,
        SingleShow:true,
        Value:''
    },{
        ControlType:'TextArea',
        FieldName:'SingleMemo',
        Title:'',
        IsRequired: false,
        Value:''
    }],
    LockPassword:[{
        ControlType:'TextBox',
        FieldName:'account',
        Title:'收银账号',
        IsRequired: true,
        Value:''
    },{
        ControlType:'PwdTextBox',
        FieldName:'LockPassword',
        Title:'密码',
        IsRequired: true,
        Value:''
    }],
    PwdAuth:[{
        ControlType:'PwdTextBox',
        FieldName:'authPwd',
        Title:'密码',
        IsRequired: true,
        Value:''
    }],
    OtherAuth:[{
        ControlType:'TextBox',
        FieldName:'authUserName',
        Title:'用户',
        IsRequired: true,
        Value:''
    },{
        ControlType:'PwdTextBox',
        FieldName:'authPwd',
        Title:'密码',
        IsRequired: true,
        Value:''
    }],
    WriteBatch:[{
        ControlType:'TextBox',
        FieldName:'Batch',
        Title:'批号',
        Value:'',
        State:'',
        Label:'',
        placeholder:'请输入批号'
    },{
        ControlType:'NumTextBox',
        FieldName:'Quantity',
        Title:'零售数量',
        Value:'',
        State:'',
        Label:'',
        placeholder:'请输入零售数量'
    },{
        ControlType:'DatePicker',
        FieldName:'ProductionDate',
        Title:'生产日期',
        Value:'',
        placeholder:'0000-00-00'
    },{
        ControlType:'DatePicker',
        FieldName:'ExpiryDate',
        Title:'失效日期',
        Value:'',
        placeholder:'0000-00-00'
    }]
}


export default function filterField(key){  
    return _cloneDeep(formColumns[key]||[]);
}